module.exports = __webpack_public_path__ + "static/media/german_rocket_artillery_120.39faa6cd.png";